import React from 'react';
import { useIntl } from 'react-intl';

import { RadioButton, RadioButtonGroup } from 'carbon-react/lib/components/radio-button';

interface ReviewBeforeSendingProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export const ReviewBeforeSending = ({ value, onChange }: ReviewBeforeSendingProps) => {
  const intl = useIntl();

  return (
    <RadioButtonGroup
      legend={intl.formatMessage({
        id: 'predict.review_before_sending',
        defaultMessage: 'Review before sending?'
      })}
      name="review-before-sending"
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        onChange(e.target.value === 'yes')
      }
      value={value ? 'yes' : 'no'}
      required
    >
      <RadioButton
        id="review-yes"
        value="yes"
        label={intl.formatMessage({ id: 'predict.yes', defaultMessage: 'Yes' })}
      />
      <RadioButton
        id="review-no"
        value="no"
        label={intl.formatMessage({ id: 'predict.no', defaultMessage: 'No' })}
      />
    </RadioButtonGroup>
  );
};
